import React from "react";
import { Link } from "react-router-dom";

const Nav = () => {
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // Calculer la position avec un offset de -80px pour le header fixe
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 80;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      // Fermer le menu mobile s'il est ouvert
      const mobileMenu = document.querySelector(".mobilemenu-popup");
      const mobileOverlay = document.querySelector(".mobilemenu-overlay");
      const body = document.querySelector("body");
      
      if (mobileMenu?.classList.contains("show")) {
        mobileMenu.classList.remove("show");
        mobileOverlay?.classList.remove("show");
        body?.classList.remove("mobilemenu-show");
      }
    }
  };

  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        
        <li>
          <a href="#comment-ca-marche" onClick={(e) => { e.preventDefault(); scrollToSection('comment-ca-marche'); }}>
            Comment ça marche
          </a>
        </li>
        <li>
          <a href="#qui-sont-nos-locataires" onClick={(e) => { e.preventDefault(); scrollToSection('qui-sont-nos-locataires'); }}>
            Nos locataires
          </a>
        </li>
        <li>
          <a href="#blog" onClick={(e) => { e.preventDefault(); scrollToSection('blog'); }}>
            Blog
          </a>
        </li>
        <li>
          <a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}>
            FAQ
          </a>
        </li>
        <li>
          <a href="#estimation" onClick={(e) => { e.preventDefault(); scrollToSection('estimation'); }}>
            Estimation gratuite
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
